<template>
  <div>
    <order-service-autocomplete @selected="serviceSelected" :placeholder="this.$gettext('Reference, or External ID')" />
    <b-badge v-for="(item, index) in services" :key="'service' + index" class="mr-1">
      {{ item.external_id }}
      <b-badge variant="danger" href="#" @click.prevent="removeService(index)">×</b-badge>
    </b-badge>
  </div>
</template>

<script>
import OrderServiceAutocomplete from '@/components/Autocompletes/OrderServiceAutocomplete'

export default {
  name: 'EditFieldOrderServices',
  components: {
    OrderServiceAutocomplete
  },
  props: {
    value: {}
  },
  data() {
    return {
      services: []
    }
  },
  watch: {
    value: {
      deep: true,
      handler(newValue, oldValue) {
        if (JSON.stringify(newValue) !== JSON.stringify(oldValue) && (newValue.length === 0 || newValue[0].external_id)) {
          this.services = newValue
        }
      }
    },
    services: {
      deep: true,
      handler(newValue, oldValue) {
        this.emitSelected()
      }
    }
  },
  methods: {
    serviceSelected(item) {
      if (this.services.findIndex(x => x.id === item.id) === -1) {
        this.services.push(item)
      }
    },
    removeService(index) {
      this.services.splice(index, 1)
    },
    emitSelected() {
      this.$emit('selected', this.services.map(x => x.id))
    }
  }
}
</script>
